/**
 * Serbian food name (DB `foods.name`) → English when no `foods.name_en` is set.
 * Display order for EN: DB `name_en` → this map → Serbian `name`.
 */
export const FOOD_NAME_EN = {
  Jabuka: 'Apple',
  Kruška: 'Pear',
  Šljiva: 'Plum',
  Breskva: 'Peach',
  Kajsija: 'Apricot',
  Dunja: 'Quince',
  Grožđe: 'Grapes',
  Trešnja: 'Cherry',
  Višnja: 'Sour cherry',
  Jagoda: 'Strawberry',
  Malina: 'Raspberry',
  Kupina: 'Blackberry',
  Ribizla: 'Red currant',
  Smokva: 'Fig',
  Lubenica: 'Watermelon',
  Dinja: 'Melon',
  Nar: 'Pomegranate',
  Kesten: 'Chestnut',
  Limun: 'Lemon',
  Limeta: 'Lime',
  Pomorandža: 'Orange',
  Mandarina: 'Mandarin',
  Grejpfrut: 'Grapefruit',
  Banana: 'Banana',
  Avokado: 'Avocado',
  Mango: 'Mango',
  Ananas: 'Pineapple',
  Kivi: 'Kiwi',
  Marakuja: 'Passion fruit',
  'Suve šljive': 'Dried plums (prunes)',
  'Suve smokve': 'Dried figs',
  'Suvo grožđe': 'Raisins',
  Brusnica: 'Cranberry',
  Borovnica: 'Blueberry',
  'Goji bobice': 'Goji berries',
  Acai: 'Acai',
  Papaja: 'Papaya',
  'Zelena salata': 'Green lettuce',
  'Iceberg salata': 'Iceberg lettuce',
  Rukola: 'Arugula',
  Radič: 'Radicchio',
  Endivija: 'Endive',
  Matovilac: "Lamb's lettuce",
  Spanać: 'Spinach',
  Blitva: 'Swiss chard',
  Kupus: 'Cabbage',
  'Kiseli kupus': 'Sauerkraut',
  'Mladi luk': 'Spring onion',
  'Crni luk': 'Onion',
  Paradajz: 'Tomato',
  'Cherry paradajz': 'Cherry tomatoes',
  Krastavac: 'Cucumber',
  Paprika: 'Bell pepper',
  Cvekla: 'Beetroot',
  Šargarepa: 'Carrot',
  Rotkvice: 'Radish',
  Grašak: 'Peas',
  Pasulj: 'Beans (dry)',
  Sočivo: 'Lentils',
  Brokoli: 'Broccoli',
  Karfiol: 'Cauliflower',
  Artičoka: 'Artichoke',
  Kelj: 'Kale',
  Prokelj: 'Brussels sprouts',
  Tikvica: 'Zucchini',
  Patlidžan: 'Eggplant',
  Špargla: 'Asparagus',
  Keleraba: 'Kohlrabi',
  Praziluk: 'Leek',
  Badem: 'Almond',
  Lešnik: 'Hazelnut',
  Orah: 'Walnut',
  Kikiriki: 'Peanut',
  'Indijski orah': 'Cashew',
  Pistaci: 'Pistachios',
  'Lanene semenke': 'Flax seeds',
  'Čia semenke': 'Chia seeds',
  'Suncokretove semenke': 'Sunflower seeds',
  Susam: 'Sesame',
  Golica: 'Pumpkin seeds',
  Tahini: 'Tahini',
  'Kikiriki puter': 'Peanut butter',
  'Bademov puter': 'Almond butter',
  Humus: 'Hummus',
  'Maslinovo ulje': 'Olive oil',
  Masline: 'Olives',
  'Kokosovo ulje': 'Coconut oil',
  Puter: 'Butter',
  'Laneno ulje': 'Flaxseed oil',
  'Bundevino ulje': 'Pumpkin seed oil',
  'Brazilski orah': 'Brazil nut',
  Hleb: 'Bread',
  Testenine: 'Pasta',
  Pirinač: 'Rice',
  'Integralni pirinač': 'Brown rice',
  Krompir: 'Potato',
  Batat: 'Sweet potato',
  Kukuruz: 'Corn',
  Palenta: 'Polenta',
  'Ovsene pahuljice': 'Rolled oats',
  Heljda: 'Buckwheat',
  Spelta: 'Spelt',
  Kinoa: 'Quinoa',
  Kuskus: 'Couscous',
  Amarant: 'Amaranth',
  Proso: 'Millet',
  'Integralne testenine': 'Whole wheat pasta',
  Musli: 'Muesli',
  'Integralne Tortilje': 'Whole wheat tortillas',
  'Ražene pahuljice': 'Rye flakes',
  'Heljdine pahuljice': 'Buckwheat flakes',
  'Pirinčane pahuljice': 'Rice flakes',
  Bulgur: 'Bulgur',
  'Kineska mešavina': 'Chinese vegetable mix',
  'Carska mešavina': 'Imperial vegetable mix',
  'Bulgur mešavina': 'Bulgur vegetable mix',
  'Mediteranska mešavina': 'Mediterranean vegetable mix',
  'Kinoa mešavina': 'Quinoa vegetable mix',
  'Zlatna mešavina': 'Golden vegetable mix',
  'Đuveč mešavina': 'Vegetable stew mix (đuveč)',
  'Meksička mešavina': 'Mexican vegetable mix',
  Cornflakes: 'Cornflakes',
  Griz: 'Semolina',
  'Balkanska mešavina': 'Balkan vegetable mix',
  Med: 'Honey',
  Džem: 'Jam',
  'Svinjski but': 'Pork leg',
  Junetina: 'Beef',
  'Pileći batak': 'Chicken drumstick',
  'Pileći karabatak': 'Chicken thigh',
  'Pileće grudi': 'Chicken breast',
  'Ćureće grudi': 'Turkey breast',
  'Ćureći karabatak': 'Turkey thigh',
  Teletina: 'Veal',
  Som: 'Catfish',
  Losos: 'Salmon',
  Tuna: 'Tuna',
  Sardina: 'Sardine',
  Skuša: 'Mackerel',
  Oslić: 'Haddock',
  Pastrmka: 'Trout',
  Brancin: 'Sea bass',
  Šaran: 'Carp',
  Orada: 'Sea bream',
  Škarpina: 'Scorpionfish',
  Bakalar: 'Cod',
  'Ćureća prsa': 'Turkey breast',
  'Pileća prsa': 'Chicken breast',
  Džigerica: 'Liver',
  Lignje: 'Squid',
  Škampi: 'Shrimp',
  Slanina: 'Bacon',
  'Suvo meso': 'Dried meat (jerky)',
  'Suvi vrat': 'Dried pork neck',
  Pršuta: 'Prosciutto',
  Šunka: 'Ham',
  Jaja: 'Eggs',
  Belance: 'Egg whites',
  Tempeh: 'Tempeh',
  Sejtan: 'Seitan',
  'Čokoladno mleko': 'Chocolate milk',
  Mleko: 'Milk',
  Gauda: 'Gouda',
  Mocarela: 'Mozzarella',
  Edamer: 'Edam',
  Trapist: 'Trappist cheese',
  Tofu: 'Tofu',
  Feta: 'Feta',
  'Mladi sir': 'Young cheese',
  'Ella sir': 'Ella cheese',
  Skyr: 'Skyr',
  Jogurt: 'Yogurt',
  Kefir: 'Kefir',
  'Grčki jogurt': 'Greek yogurt',
  'Kiselo mleko': 'Sour milk',
  'Proteinski napitak 500ml': 'Protein drink 500ml',
  'Proteinski napitak 300ml': 'Protein drink 300ml',
  'Proteinski puding': 'Protein pudding',
  Whey: 'Whey protein',
  'Biljno mleko': 'Plant milk',
  Kakao: 'Cocoa',
  Cimet: 'Cinnamon',
  'Jabukovo sirće': 'Apple cider vinegar',
  Origano: 'Oregano',
  Biber: 'Pepper',
  Peršun: 'Parsley',
  Bosiljak: 'Basil',
  Mirođija: 'Dill',
  Vlašac: 'Chives',
  Ruzmarin: 'Rosemary',
  Aleva: 'Aleppo pepper',
  Čili: 'Chili',
  Balzamiko: 'Balsamic vinegar',
  Đumbir: 'Ginger',
  Kurkuma: 'Turmeric',
};

export function foodNameToEnglish(srName) {
  if (!srName || typeof srName !== 'string') return srName;
  return FOOD_NAME_EN[srName] || srName;
}
